import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { CommonModule } from '@angular/common';
import { EditElectricityInvoiceComponent } from "../../../invoice/components/edit-electricity-invoice/edit-electricity-invoice.component";
import { CommodityType, ElectricityInvoice, InvoiceElectricityAndCompanyGet, InvoiceElectricityPODGet, InvoiceStatus } from '../../../../core/interfaces/invoice-interfaces';
import { Location } from '../../../../core/interfaces/location';
import { InvoiceHelperService } from '../../../../core/services/invoice-helper.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { lastValueFrom } from 'rxjs';
import { InvoiceService } from '../../../../core/api/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { CompanyInformationComponent } from "../company-information/company-information.component";
import { FilesService } from '../../../../core/api/files.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-review-expanded-electricity-invoice',
  standalone: true,
  imports: [CommonModule, NgxExtendedPdfViewerModule, EditElectricityInvoiceComponent, TranslocoPipe, CompanyInformationComponent],
  templateUrl: './admin-review-expanded-electricity-invoice.component.html',
  styleUrl: './admin-review-expanded-electricity-invoice.component.css'
})
export class AdminReviewExpandedElectricityInvoiceComponent implements OnChanges, OnInit {
  constructor(private invoiceHelper: InvoiceHelperService, private invoiceService: InvoiceService, private apiError: ApiErrorService, private filesService: FilesService, private sanitizer: DomSanitizer) { }
  // Toast
  @Input() toast!: ToastComponent;

  @Input() fileUrl?: string;
  @Input() fileId?: string;

  safePdfUrl?: SafeResourceUrl

  CommodityType = CommodityType;

  // Invoice
  @Input() invoice?: InvoiceElectricityAndCompanyGet;
  @Input() baseInvoice: ElectricityInvoice | null = null;

  summedPOD?: InvoiceElectricityPODGet;

  // Locations
  @Input() listOfLocations: Location[] = [];


  // Callback
  @Input() reloadCallbackFunction!: () => void;
  @Input() createLocationSuccessCallbackFunction!: () => void;
  @Input() hardReloadCallbackFunction!: () => void;

  // Edit electricity
  @ViewChild('editElectricity') editElectricityElement?: EditElectricityInvoiceComponent;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileId']) {
      if (this.fileId) {
        this.filesService.getPdfUrl(this.fileId).subscribe(response => {
          if (response.download_url) this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.download_url);
        });
      }
    }

    if (changes['invoice']) {
      this.baseInvoice = this.invoice as ElectricityInvoice;

      if (this.baseInvoice) {
        this.summedPOD = this.invoiceHelper.getElectricityInvoicePODSummed(this.baseInvoice);
      }
    }
  }

  async downloadDisputeReport() {

    // Check if invoice is available
    if (!this.invoice) {
      return
    }

    if (this.invoice.status == InvoiceStatus.CALCULATION_FAILED) {
      this.toast.showToast("shared.error", "invoice.not_enough_data", 'error', 5000, true);
      return;
    }

    // Download report
    try {
      var responseBlob = await lastValueFrom(this.invoiceService.getElectricityDispute(this.invoice.id ?? ''));

      const blobUrl = URL.createObjectURL(responseBlob);

      window.open(blobUrl, '_blank');
    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
  }

  scroolToSpread() {
    this.editElectricityElement?.scroolToSpread();
  }
}
